import React from 'react';
import { styled } from '@compiled/react';
import { Field as AkField } from '@atlaskit/form';
import DragHandleIcon from '@atlaskit/icon/core/drag-handle';
import { toRowIndexTrackerFieldName } from '../../../../../../../../../common/utils/goal/field/index.tsx';

type Props = {
	isDefaultGoal: boolean;
	id: string;
	label: string;
	index: number;
};

export const DraggableField = ({ id, label, index, isDefaultGoal }: Props) => {
	const fieldName = toRowIndexTrackerFieldName(id, isDefaultGoal);
	return (
		<AkField name={fieldName} defaultValue={index}>
			{() => (
				<DragIconContainer>
					{}
					<DragHandleIcon LEGACY_size="large" label={label} color="currentColor" />
				</DragIconContainer>
			)}
		</AkField>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const DragIconContainer = styled.div({
	cursor: 'move',
});
